import * as React from 'react';
import ReactTable from 'react-table-6';
import { ReactTableDefaults } from 'react-table-6';
import '../../css/react-table.etool.css';
import style from './WTable.less';
import * as classNames from 'classnames';
import { WActionButton } from '../elements/WActionButton';
import { ExcelTool } from '../excel/excel_tool';
import { DiffTool } from './helpers/diff_tool';
import DialogWrapper from '../dialog/dialog_wrapper';
import { i18n } from '../../i18n/i18n';
// import { WForm } from '../forms/WForm';
// import { WFormData } from '../forms/WFormData';
import { WForm, WFormData, WFormConfig, WFormConfigItem } from '../forms/WFormFramework';
import { lazyInject } from '../../services/inversify';
import { DataService } from '../../services/data_service';
import { WTableHistory } from './WTableHistory';
import { WTableStore } from './WTableStore';
import { WTableFieldGroup } from './WTableFieldGroup';
import { WHelpIcon } from '../elements/WHelpIcon';
import { WSpinner } from '../elements/spinner/WSpinner';
import { formatDefaultExport } from './WTableFormatter';
import * as XLSX from 'xlsx';

interface WTableProps extends React.ClassAttributes<any> {
    containerId?: string;
    theme?: string;
    tableId?: string;
    module?: string;
    showView?: boolean;
    showEdit?: boolean;
    showDelete?: boolean;
    showCopy?: boolean;
    showBackup?: boolean;
    showCompare?: boolean;
    recoverBackup?: boolean;
    customActions?: ReadonlyArray<any>;
    data?: any;
    entity: string;
    columns: Array<any>;
    columnWidths?: Array<number>;
    showColumnsHelp?: boolean;                          // OnLine-Hilfe der Spalten
    showColumnsSortBtn?: boolean;                       // Button Sortierung kenntlich machen
    filterable?: boolean;
    hideFilterReset?: boolean;
    hideExport?: boolean;
    hideAllHeaderElements?: boolean;
    extraFilter?: Array<JSX.Element>;
    externalHeaderElements?: Array<JSX.Element>;
    sortHeaderElements?: Array<string>;
    enableSelection?: boolean;
    multipleSelection?: boolean;
    onShowBackup?: any;
    onShowCompare?: any;
    onSaveOriginal?: any;
    sheetName?: string;
    dataForSaveOriginal?: boolean;
    rawData?: any;
    showPagination?: boolean;
    pageSize?: number;
    forcedTableKey?: string;
    selectedRowForArray?: Array<number>;
    enableRowCheckbox?: boolean;                        // Auswahlcheckbox je Zeile aktivieren
    enableStorage?: boolean;
    showSpinner?: boolean;
    enableTableHistorie?: boolean;
    enableTableStorage?: boolean;
    showTableHelp?: boolean;
    externalRefreshIterator?: number;
    pivotBy?: Array<string>;
    expanded?: Array<any>;
    exportOptions?: any;
    onRowExpand?: (expanded: Array<any>) => void;
    onFilterChange?: (filter: Array<any>, data: Array<any>) => void;
    defaultSorted?: Array<any>;
    fixedHeader?: boolean;
    actionsBtnReihenfolg?: Array<any>;
    customClass?: string;
    customClassNames?: Array<string>;
    preCfgWTableFieldGroup?: any;
    editCondition?: (row: any) => boolean;
    checkedRows?: any;
    allCheckboxChecked?: boolean;                       // State der all-Checkbox
    onRowSelect?: (row: any, selected: boolean, checkedRows: Array<any>) => void; // ... Funktion zum Aufruf bei select/deselect
    isRowSelected?: (row: any) => boolean;                 // ... Funktion zur Prüfung, ob eine Checkbox aktiv sein muss
    isRowSelectable?: (row: any) => boolean;
    dataKeyAttribute?: string;
    timestamp?: number;                                         // Kennzeichnet, ob bei componentDidUpdate State zu aktuallisieren
    saveOriginal?: boolean;                                     // original data zum herunterladen
    globalData?: any;
    onResetFilter?: () => void;
    onAction(action: string, row: any): void;
    onSelection?(idx: any): void;
    customRechteCheck?(action: string, row: any): boolean;
    customTdProps?(state: any, rowInfo: any, column: any): any;
    customTrProps?(state: any, rowInfo: any, column: any): any;
    passDataForExport?(data: Array<any>, columns: Array<any>): void;
}

interface WTableState {
    selectedRow: any;
    selectedRowForArray: Array<number>;
    showExportToEmailPrompt?: boolean;
    dialogHistory: JSX.Element;
    dialogStore: JSX.Element;
    sheetName: string;
    filters: Array<any>;
    countFiltered: number;
    checkedRows: any;
    rowsExpanded: Array<any>;
    columns: Array<any>;
    WTableFieldGroupData: Array<any>;
    showDlgFieldGroup: boolean;
    floatboxPosX?: number;
    floatboxPosY?: number;
    currentPage: number;
}

export class WTable extends React.Component<WTableProps, WTableState> {
    constructor(props: any) {
        super(props);
        this.state = {
            selectedRowForArray: this.props.selectedRowForArray ? this.props.selectedRowForArray : [],
            selectedRow: [],
            dialogHistory: null,
            dialogStore: null,
            sheetName: this.props.sheetName ? this.props.sheetName : '',
            filters: [],
            countFiltered: undefined,
            checkedRows: this.props.checkedRows ? this.props.checkedRows : {},
            rowsExpanded: this.props.expanded ? this.props.expanded : [],
            columns: this.buildColumns(),
            showDlgFieldGroup: false,
            WTableFieldGroupData: undefined,
            currentPage: 0
        };

        this.getCellStyle = this.getCellStyle.bind(this);
        this.onExport = this.onExport.bind(this);
        this.onExportToEmail = this.onExportToEmail.bind(this);
        this.renderTableHistory = this.renderTableHistory.bind(this);
        this.renderTableStore = this.renderTableStore.bind(this);
        this.countFiltered = this.countFiltered.bind(this);
        this.onRowSelect = this.onRowSelect.bind(this);
        this.onRowExpand = this.onRowExpand.bind(this);
        this.hasFieldGroups = this.hasFieldGroups.bind(this);
        this.onSortedChange = this.onSortedChange.bind(this);
    }

    @lazyInject(DataService) private dataService: DataService;

    private propRecCounter = 0;
    private tableRef: any = undefined;

    // react-table: Header Filter Input Losing Focus After Keydown - issue #1266
    // Im Production-Build kann es Probleme geben, die im lokalen Test nicht auftreten.
    // Problem: Filter verliert den Fokus, wenn man einen Buchstaben eingibt.
    // Lösung: Colum muss außer dem Render definiert werden.
    private columRender: any = {
        ...ReactTableDefaults.column,
        // Suchmöglichkeit kenntlich machen (z.B. in grau "Suchbegriff eingeben")
        Filter: ({ filter, onChange }: any) => (
            <input
                style={{ width: '100%', height: '18px' }}
                type='text'
                placeholder={i18n('Suchbegriff eingeben', 'sys')}
                value={filter ? filter.value : ''}
                onChange={event => onChange(event.target.value)}
            />
        )
    };

    UNSAFE_componentWillReceiveProps() {
        window.setTimeout(() => {
            this.setState({ columns: this.buildColumns() });
        }, 10);
    }
    buildColumns() {
        let columns = [...this.props.columns];
        columns = this.addActionColumns(columns);
        columns = this.modifyColumns(columns);
        columns = this.hideColumns(columns);
        columns = this.addColumnsBtns(columns);
        return columns;
    }

    componentDidUpdate(prevProps: any) {
        // console.log(prevProps, this.props);
        if (this.props.tableId !== prevProps.tableId) {
            this.setState({ checkedRows: {} });
        }
        if (this.props.timestamp > 0 && prevProps.timestamp > 0 && this.props.timestamp !== prevProps.timestamp) {
            // Set selected by isRowSelected
            if (this.props.checkedRows) {
                this.setState({ checkedRows: this.props.checkedRows });
            } else if (typeof this.props.isRowSelected === 'function') {
                if (Array.isArray(this.props.data) && this.props.data.length > 0) {
                    const checkedRows = this.state.checkedRows;
                    const keyName = this.props.dataKeyAttribute ? this.props.dataKeyAttribute : 'tid';
                    this.props.data.forEach((dataRow: any) => {
                        const checked = this.props.isRowSelected(dataRow);
                        if (typeof checked === 'boolean') {
                            const dkey = dataRow[keyName];
                            checkedRows[dkey] = checked;
                        }
                    });
                    this.setState({ checkedRows });
                }
            }

            // Update this.props.expanded
            const preExpStr = JSON.stringify(prevProps.expanded);
            const newExpStr = JSON.stringify(this.props.expanded);
            if (preExpStr !== newExpStr) {
                this.setState({ rowsExpanded: this.props.expanded });
            }
        }
    }

    modifyColumns(columns: Array<any>) {
        columns = columns.map((col, idx) => {
            if (this.props.columnWidths && this.props.columnWidths.length > idx && this.props.columnWidths[idx] > 0) {
                col.width = this.props.columnWidths[idx];
            }
            return col;
        });
        // console.log('WTable modifyColums');
        // console.log(columns);
        return columns;
    }

    hideColumns(columns: Array<any>) {
        if (this.props.preCfgWTableFieldGroup) {
            if (typeof this.props.preCfgWTableFieldGroup.hidden === 'object') {
                const hiddenObj = this.props.preCfgWTableFieldGroup.hidden;
                columns = columns.map((col: any) => {
                    if (col.field_group && hiddenObj[col.field_group]) {
                        col.show = false;
                    }
                    return col;
                });
            }
        }
        return columns;
    }

    addColumnsBtns(columns: Array<any>) {
        columns = columns.map((col: any) => {
            if (col.Header && !col.columnsBtnsRendered) {
                let help = null, sort = null;
                if (this.props.showColumnsHelp) {
                    help = this.renderColumnsHelp(col);
                }
                if (this.props.showColumnsSortBtn) {
                    sort = this.renderColumnsSortBtn(col);
                }
                col.Header_orig = col.Header;
                col.Header = <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <div style={{ display: 'flex', flexDirection: 'row' }}>{help} {sort}</div>
                    <div>{col.Header}</div>
                </div>;
                col.columnsBtnsRendered = true;
            }
            return col;
        });
        return columns;
    }

    addActionColumns(columns: Array<any>) {
        // Hier noch laden von woanders
        // console.log('WTPROPS: ', this.props);
        const { theme } = this.props;
        const origColumnsLength = columns.length;
        const reihenFolge = this.props.actionsBtnReihenfolg && this.props.actionsBtnReihenfolg.length > 0 ? true : false;
        if (this.props.showView) {
            const viewColumn: any = {
                width: 42,
                Header: '', // 'Bearb.'
                accessor: 'a',
                isCustomAction: true,
                filterable: false,
                Cell: (row: any) => {
                    if (row.original && row.original._noActions) {
                        return <span />;
                    }
                    const dataRow = row.original;
                    if (this.props.customRechteCheck) {
                        const suc = this.props.customRechteCheck('view', dataRow);
                        if (!suc) {
                            return <span />;
                        }
                    }
                    return (
                        <WActionButton
                            style={theme ? `theme_${theme}` : 'theme'}
                            label='Ansehen'
                            action='view'
                            key={'but_view'}
                            onAction={(action: string) => this.props.onAction(action, dataRow)}
                            tooltip={'Eine Ansicht des Datensatzes wird geöffnet.'}
                        />
                    );
                }
            };
            if (reihenFolge) {
                viewColumn.name = 'view';
            }
            columns.push(viewColumn);
        }
        if (this.props.showEdit) {
            const editColumn: any = {
                width: 42,
                Header: '', // 'Bearb.'
                accessor: 'a',
                isCustomAction: true,
                filterable: false,
                Cell: (row: any) => {
                    if (row.original && row.original._noActions) {
                        return <span />;
                    }
                    const dataRow = row.original;
                    if (this.props.customRechteCheck) {
                        const suc = this.props.customRechteCheck('edit', dataRow);
                        if (!suc) {
                            return <span />;
                        }
                    }
                    if (this.props.editCondition && !this.props.editCondition(dataRow)) {
                        return (
                            <WActionButton
                                style={theme ? `theme_${theme}` : 'theme'}
                                label='Ansehen'
                                action='view'
                                key={'but_view'}
                                onAction={(action: string) => this.props.onAction(action, dataRow)}
                                tooltip={'Eine Ansicht des Datensatzes wird geöffnet.'}
                            />
                        );
                    } else {
                        return (
                            <WActionButton
                                style={theme ? `theme_${theme}` : 'theme'}
                                label='Bearbeiten'
                                action='edit'
                                key={'but_edit'}
                                onAction={(action: string) => this.props.onAction(action, dataRow)}
                                tooltip={i18n('Ein Dialog zum Bearbeiten des Datensatzes wird geöffnet.', 'sys')}
                            />
                        );
                    }
                }
            };
            if (reihenFolge) {
                editColumn.name = 'edit';
            }
            columns.push(editColumn);
        }
        if (this.props.showCopy) {
            const copyColumn: any = {
                width: 42,
                Header: '', // 'Löschen'
                accessor: 'a',
                isCustomAction: true,
                filterable: false,
                Cell: (row: any) => {
                    if (row.original && row.original._noActions) {
                        return <span />;
                    }
                    const dataRow = row.original;
                    if (this.props.customRechteCheck) {
                        const suc = this.props.customRechteCheck('copy', dataRow);
                        if (!suc) {
                            return <span />;
                        }
                    }
                    return (
                        <WActionButton
                            style={theme ? `theme_${theme}` : 'theme'}
                            label='Kopieren'
                            action='copy'
                            key={'but_copy'}
                            onAction={(action: string) => this.props.onAction(action, dataRow)}
                            tooltip={i18n('Der Datensatz wird kopieren.', 'sys')}
                        />
                    );
                }
            };
            if (reihenFolge) {
                copyColumn.name = 'copy';
            }
            columns.push(copyColumn);

        }
        if (this.props.showBackup) {
            const showBackupColumn: any = {
                width: 42,
                Header: '', // 'Löschen'
                accessor: 'a',
                isCustomAction: true,
                filterable: false,
                Cell: (row: any) => {
                    if (row.original && row.original._noActions) {
                        return <span />;
                    }
                    const dataRow = row.original;
                    return (
                        <WActionButton
                            style={theme ? `theme_${theme}` : 'theme'}
                            label='Anzeigen'
                            action={dataRow.backup_id ? 'show' : 'unshow'}
                            disabled={dataRow.backup_id ? false : true}
                            key={'but_show'}
                            onAction={() => this.props.onShowBackup(dataRow)}
                            tooltip={dataRow.backup_id ? 'Daten ansehen/herunterladen' : 'Keine Backup vorhanden.'}
                        />
                    );
                }
            };
            if (reihenFolge) {
                showBackupColumn.name = 'showBackup';
            }
            columns.push(showBackupColumn);
        }
        if (this.props.showCompare) {
            const showCompareColumn: any = {
                width: 42,
                Header: '', // 'Löschen'
                accessor: 'a',
                isCustomAction: true,
                filterable: false,
                Cell: (row: any) => {
                    if (row.original && row.original._noActions) {
                        return <span />;
                    }
                    const dataRow = row.original;
                    return (
                        <WActionButton
                            style={theme ? `theme_${theme}` : 'theme'}
                            label='Anzeigen'
                            action={dataRow.backup_id ? 'compare' : null}
                            disabled={dataRow.backup_id ? false : true}
                            key={'but_compare'}
                            onAction={() => this.props.onShowCompare(dataRow)}
                            tooltip={dataRow.backup_id ?
                                'Backup wird mit aktuellem Stand verglichen und Unterschiede angezeigt.' :
                                'Keine Backup vorhanden.'}
                        />
                    );
                }
            };
            if (reihenFolge) {
                showCompareColumn.name = 'showCompare';
            }
            columns.push(showCompareColumn);
        }

        if (this.props.saveOriginal) {
            const downloadOrigData: any = {
                width: 42,
                Header: '', // 'Löschen'
                accessor: 'a',
                isCustomAction: true,
                filterable: false,
                Cell: (row: any) => {
                    const dataRow = row.original;
                    return (
                        <WActionButton
                            style={theme ? `theme_${theme}` : 'theme'}
                            label='Anzeigen'
                            action={dataRow.backup_id ? 'save' : null}
                            disabled={dataRow.backup_id ? false : true}
                            key={'but_save'}
                            onAction={() => this.props.onSaveOriginal(dataRow)}
                            tooltip={dataRow.backup_id ?
                                'Original Data zum herunterladen' :
                                'Keine Original Data vorhanden.'}
                        />
                    );
                }
            };
            if (reihenFolge) {
                downloadOrigData.name = 'donwloadOrigData';
            }
            columns.push(downloadOrigData);
        }
        if (this.props.customActions) {
            // console.log(this.props.customActions);
            this.props.customActions.forEach((action: any, idx: number) => {
                const customActionColumn: any = {
                    width: 42,
                    Header: '', // ''
                    accessor: 'a',
                    isCustomAction: true,
                    filterable: false,
                    Cell: (row: any) => {
                        if (row.original && row.original._noActions) {
                            return <span />;
                        }
                        if (row === undefined || row.original === undefined) {
                            return null;
                        }
                        const dataRow = row.original;
                        let buttonKey = action.key ? action.key : '';
                        if (dataRow.buttonMode) {
                            buttonKey = dataRow.buttonMode;
                        }
                        let actionStyle = undefined;
                        if (action.styleFunc) {
                            actionStyle = action.styleFunc(dataRow);
                        }
                        return (
                            <WActionButton
                                style={theme ? `theme_${theme}` : 'theme'}
                                label={action.label}
                                action={buttonKey}
                                key={'but_' + buttonKey}
                                onAction={() => action.func(dataRow, row.index)}
                                tooltip={action.info}
                                styleProps={actionStyle}
                            />
                        );
                    }
                };
                if (reihenFolge) {
                    customActionColumn.name = action.id ? action.id : 'customAction_' + idx;
                }
                columns.push(customActionColumn);
            });
        }
        if (this.props.showDelete) {
            const deleteColumn: any = {
                width: 42,
                Header: '', // 'Löschen'
                accessor: 'a',
                isCustomAction: true,
                filterable: false,
                Cell: (row: any) => {
                    if (row.original && row.original._noActions) {
                        return <span />;
                    }
                    const dataRow = row.original;
                    if (this.props.customRechteCheck) {
                        const suc = this.props.customRechteCheck('delete', dataRow);
                        if (!suc) {
                            return <span />;
                        }
                    }
                    return (
                        <WActionButton
                            style={theme ? `theme_${theme}` : 'theme'}
                            label='Löschen'
                            action='delete'
                            key={'but_delete'}
                            onAction={(action: string) => this.props.onAction(action, dataRow)}
                            tooltip={i18n('Der Datensatz wird entfernt.', 'sys')}
                        />
                    );
                }
            };
            if (reihenFolge) {
                deleteColumn.name = 'delete';
            }
            columns.push(deleteColumn);
        }
        if (this.props.enableRowCheckbox) {
            const headerBox = (
                <div style={{ textAlign: 'center' }}
                    onClick={
                        (evt: any) => {
                            const checkedAllRows = !this.props.allCheckboxChecked;
                            const checkedRows: any = {};
                            if (checkedAllRows) {
                                const data = this.tableRef.getResolvedState().sortedData;
                                const keyName = this.props.dataKeyAttribute ? this.props.dataKeyAttribute : 'tid';
                                data.forEach((d: any) => {
                                    if (d._original && d._original[keyName]) {
                                        const k = d._original[keyName];
                                        checkedRows[k] = checkedAllRows;
                                    }
                                });
                            }
                            this.setState({ checkedRows });
                            if (typeof this.props.onRowSelect === 'function') {
                                this.props.onRowSelect({ tid: 'all' }, evt.target.checked, checkedRows);
                            }
                            evt.stopPropagation();
                        }
                    }
                >
                    <input
                        type='checkbox'
                        key={this.props.forcedTableKey ? this.props.forcedTableKey + '_ch_head' : 'ch_head'}
                        checked={this.props.allCheckboxChecked}
                    />
                </div>
            );
            const showCheckbox = {
                width: 50,
                Header: headerBox,
                accessor: 'a',
                isCustomAction: true,
                filterable: false,
                Cell: (row: any) => {
                    const dataRow = row.original;
                    const keyName = this.props.dataKeyAttribute ? this.props.dataKeyAttribute : 'tid';
                    return (
                        <div style={{ textAlign: 'center' }} id={'row_select' + dataRow[keyName]}>
                            {!this.props.isRowSelectable || this.props.isRowSelectable(dataRow) ?
                                <input
                                    type='checkbox'
                                    checked={dataRow && dataRow[keyName] && this.state.checkedRows[dataRow[keyName]] ? true : false}
                                    onChange={(evt: any) => this.onRowSelect(dataRow, evt.target.checked)}
                                />
                                : ''
                            }
                        </div>);
                }
            };
            columns.push(showCheckbox);
        }
        if (reihenFolge) {
            this.props.actionsBtnReihenfolg.forEach((n: any, id: number) => {
                const result = columns.find(({ name }) => name === n);
                if (result) {
                    delete result.name;
                    columns.splice(origColumnsLength + id, 0, result);
                }
            });
            columns.length = origColumnsLength + this.props.actionsBtnReihenfolg.length;
        }
        // Sticky alle Funktion-Spalten
        let toRight = 0;
        let lastFktCol: any;
        for (let i = columns.length - 1; i >= 0; i--) {
            if (columns[i].accessor === 'a' || columns[i].isCustomAction) {
                columns[i].className = 'stickyRight';
                columns[i].headerClassName = 'stickyRight';
                columns[i].style = { right: toRight };
                columns[i].headerStyle = { right: toRight };
                lastFktCol = columns[i];
                toRight += lastFktCol.width > 0 ? lastFktCol.width : 0;
            }
        }
        return columns;
    }

    onRowSelect(dataRow: any, checked: boolean) {
        const checkedRows = this.state.checkedRows;
        const keyName = this.props.dataKeyAttribute ? this.props.dataKeyAttribute : 'tid';
        const dkey = dataRow[keyName];
        checkedRows[dkey] = checked;
        this.setState({ checkedRows });
        if (typeof this.props.onRowSelect === 'function') {
            this.props.onRowSelect(dataRow, checked, checkedRows);
        }
    }

    renderExportToEmailPrompt() {
        const formData = new WFormData();
        // formData.setValue('email', 'bsp@bsp.de');
        //  console.log('WTable get SessionStorage : ');
        // console.log(sessionStorage);
        formData.setValue('email',
            (sessionStorage.getItem('LOGIN_USER_EMAIL') ? sessionStorage.getItem('LOGIN_USER_EMAIL') : 'bsp@bsp.de')
        ); // TODO JN: User-Email holen
        const formConfig = new WFormConfig();
        formConfig.name = 'promptEmail';
        const item: WFormConfigItem = { key: 'email', label: 'Email', typ: 'mail', required: true };
        formConfig.addItem(item);
        const customLayout = this.props.module === 'ber' || this.props.customClass === 'ber' ? 'ber' : null;
        return (
            <div>
                <DialogWrapper onAfterClose={() => this.setState({ showExportToEmailPrompt: false })}>
                    <WForm
                        layout={customLayout ? customLayout : 'sidebysideWIPS'}
                        titel='Email-Adresse für Export'
                        dataIn={formData}
                        config={formConfig}
                        onFormSave={this.onExportToEmail}
                        hideCancel={true}
                        onFormCancel={() => { }}
                        validRestriction='stop'
                    />
                </DialogWrapper>
            </div>
        );
    }

    renderTableHistory() {
        this.dataService.getTableHistorie(this.props.module, this.props.entity, this.props.tableId, (data: string, suc: boolean) => {
            // console.log(data);
            let historie;
            try {
                historie = JSON.parse(data);
            } catch (e) {
                console.error(e);
            }
            if (historie && typeof historie === 'object') {
                this.setState({
                    dialogHistory:
                        <div>
                            <DialogWrapper
                                onAfterClose={() => { this.setState({ dialogHistory: null }); }}
                            >
                                <WTableHistory
                                    entity={this.props.entity}
                                    data={historie}
                                    columns={this.props.columns}
                                />
                            </DialogWrapper>
                        </div>
                });
            } else {
                alert('Es wurden keine Daten gefunden.');
            }
        });
    }

    renderTableStore() {
        this.dataService.getTableStore(this.props.entity, this.props.tableId, (data: string, suc: boolean) => {
            console.log(data, suc);
            let store;
            try {
                store = JSON.parse(data);
            } catch (e) {
                console.error(e);
            }
            if (store && typeof store === 'object') {
                this.setState({
                    dialogStore:
                        <div>
                            <DialogWrapper
                                onAfterClose={() => { this.setState({ dialogStore: null }); }}
                                title='Tabelle-Historie anzeigen'
                            >
                                <WTableStore
                                    module={this.props.module}
                                    entity={this.props.entity}
                                    data={store}
                                    WTableData={this.props.data}
                                />
                            </DialogWrapper>
                        </div>
                });
            } else {
                alert('Es wurden keine Daten gefunden.');
            }
        });
    }

    renderBtnShowHistory() {
        const { theme } = this.props;
        if (this.props.enableTableHistorie) {
            return (
                <WActionButton
                    style={theme ? `theme_${theme}` : 'theme'}
                    label='Datensatz-Historie anzeigen'
                    action='historie'
                    key='action_historie'
                    onAction={this.renderTableHistory}
                    tooltip='Datensatz-Historie anzeigen'
                />
            );
        }
    }

    renderBtnSetStore() {
        const { theme } = this.props;
        if (this.props.enableTableStorage) {
            const entity = this.props.entity;
            const tableId = this.props.tableId;
            const data = this.props.data;
            const callback = (res: string, suc: boolean) => {
                console.log(res, suc);
                if (suc && typeof res === 'string' && res.toLowerCase() === 'true') {
                    alert('Tabelle wurde gespeichert.');
                } else {
                    alert('Tabelle wurde NICHT gespeichert.');
                }
            };
            return (
                <WActionButton
                    style={theme ? `theme_${theme}` : 'theme'}
                    label='Tabelle speichern'
                    action='table_store'
                    key={'action_table_store'}
                    onAction={() => {
                        this.dataService.setTableStore(entity, tableId, data, '', callback);
                    }}
                    tooltip={'Tabelle speichern'}
                />
            );
        }
    }

    renderBtnShowStore() {
        const { theme } = this.props;
        if (this.props.enableTableStorage) {
            return (
                <WActionButton
                    style={theme ? `theme_${theme}` : 'theme'}
                    label='Tabelle-Historie anzeigen'
                    action='table_historie'
                    key='action_table_historie'
                    onAction={this.renderTableStore}
                    tooltip='Tabelle-Historie anzeigen'
                />
            );
        }
    }

    renderTableHelp() {
        const { theme } = this.props;
        if (this.props.showTableHelp) {
            const helpKey = this.props.tableId;
            const helpKey2 = (this.props.module ? this.props.module : 'nomodule')
                + '_' + (this.props.entity ? this.props.entity : 'noentity');
            // console.log(helpKey, helpKey2);
            return (
                <div style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center', paddingRight: '20px' }}>
                    <WHelpIcon
                        containerId={this.props.containerId}
                        style={theme ? `theme_${theme}` : 'theme'}
                        type={theme ? `theme_info_${theme}` : 'theme_info'}
                        data={this.props.globalData}
                        styleProps={{
                            width: '18px', height: '20px', borderRadius: '10px', backgroundColor: 'transparent', verticalAlign: 'top', margin: '0px'
                        }}
                        label='Info'
                        helpKey={helpKey || helpKey2}
                        editBar={true}
                        useTheme
                    />
                </div>
            );
        }
    }

    renderColumnsHelp(col: any) {
        const { theme } = this.props;
        let helpKey = (this.props.module ? this.props.module : 'nomodule')
            + '_' + (this.props.entity ? this.props.entity : 'noentity');
        helpKey += '_' + col.accessor;
        return (
            <WHelpIcon
                containerId={this.props.containerId}
                style={theme ? `theme_${theme}` : 'theme'}
                type={theme ? `theme_info_${theme}` : 'theme_info'}
                data={this.props.globalData}
                styleDivProps={{ marginLeft: 10 }}
                styleProps={{
                    width: '18px', height: '20px', borderRadius: '10px', backgroundColor: 'transparent', verticalAlign: 'top', margin: '0px'
                }}
                label={'Info "' + col.HeaderText + '"'}
                helpKey={helpKey}
                editBar={true}
                useTheme
            />
        );
    }

    renderColumnsSortBtn(col: any) {
        const t = col.sortBtnStatus === 1 ? '▲' : col.sortBtnStatus === -1 ? '▼' : '▲/▼';
        const s = col.sortBtnStatus === 1 || col.sortBtnStatus === -1 ? { color: 'black' } : { color: 'lightgray' };
        return (
            <div style={{ ...s, ...{ marginLeft: 10, minWidth: 30 } }}>{t}</div>
        );
    }

    onSortedChange(newSorted: any, column: any) {
        // console.log(newSorted, column);
        if (Array.isArray(newSorted) && newSorted.length > 0) {
            const sort = newSorted[0];
            const columns = this.props.columns;
            columns.forEach((c: any) => {
                if (c.accessor === sort.id) {
                    c.sortBtnStatus = sort.desc ? -1 : 1;
                } else {
                    c.sortBtnStatus = 0;
                }
                c.Header = c.Header_orig;
                c.columnsBtnsRendered = false;
            });
            this.setState({ columns: this.buildColumns() });
        }
    }

    hasFieldGroups() {
        const found = this.state.columns.find((r: any) => { return typeof r.field_group === 'string' && r.field_group !== ''; });
        if (found) {
            return true;
        }
        return false;
    }

    hasHiddenByFieldGroups() {
        let cnt = 0;
        this.state.columns.map((r: any) => {
            if (r.show_orig === undefined && r.show === false) {
                cnt++;
            }
        });
        return cnt;
    }

    renderDlgFieldGroup() {
        if (this.state.showDlgFieldGroup) {
            return (
                <WTableFieldGroup
                    columns={this.state.columns}
                    posX={this.state.floatboxPosX}
                    posY={this.state.floatboxPosY}
                    cfgData={this.state.WTableFieldGroupData}
                    preCfg={this.props.preCfgWTableFieldGroup}
                    onChange={(columns: Array<any>, WTableFieldGroupData: Array<any>) => {
                        this.setState({ columns: [] }, () => {
                            this.setState({ columns, WTableFieldGroupData });
                        });
                    }}
                    onMouseLeave={() => {
                        this.setState({ showDlgFieldGroup: false, floatboxPosX: null, floatboxPosY: null });
                    }}
                />
            );
        }
    }

    render() {
        let pageSize = this.props.pageSize ? +this.props.pageSize : 10;
        if (this.props.data && this.props.data.length < pageSize) {
            pageSize = this.props.data.length;
        }
        // "HACK" damit auch die Änderungen am Inputfeld in der Mitte sofort greifen
        const selector: any = $('.-pageJump');
        if (selector && selector[0] && selector[0].firstChild) {
            if (!selector[0].firstChild.onchange) {
                selector[0].firstChild.onchange = (evt: any) => {
                    const newPage = +evt.target.value - 1;
                    // console.log('NEW PAGE1: ' + newPage);
                    if (newPage >= 0) {
                        this.setState({ currentPage: newPage });
                    } else {
                        this.setState({ currentPage: 0 });
                        evt.target.value = 0;
                    }
                };
            }
            if (!selector[0].firstChild.onkeyup) {
                selector[0].firstChild.onkeyup = (evt: any) => {
                    const num = +evt.target.value;
                    // console.log('NEW PAGE2: ' + num);
                    if (num > 0) {
                        this.setState({ currentPage: (num - 1) });
                    }
                };
            }
        }
        let showPage = this.state.currentPage < 0 ? 0 : this.state.currentPage;
        if (!isNaN(this.state.countFiltered)) {
            const maxPage = Math.ceil(this.state.countFiltered / pageSize) - 1;
            if (maxPage < showPage) {
                showPage = maxPage;
            }
        }
        if (showPage < 0) {
            showPage = 0;
        }
        if (+showPage !== +this.state.currentPage) {
            // console.log('NEW PAGE3: ' + showPage, this.state.currentPage);
            this.setState({ currentPage: showPage });
        }
        const tableKey = this.props.forcedTableKey ? this.props.forcedTableKey :
            'rt_' + this.propRecCounter + '_' + pageSize + '_' + this.props.externalRefreshIterator;

        const dataVerified: Array<any> = this.props.data;
        if (this.props.columns && this.props.columns.length > 0) {
            dataVerified.forEach((item: any) => {
                this.props.columns.forEach((c: any) => {
                    if (!item[c.accessor]) {
                        item[c.accessor] = '';
                    }
                });
            });
        }
        return (
            <div
                className={style.tableDiv}
                style={{ flex: 1, display: 'flex', flexDirection: 'column', minHeight: 0 }}
            >
                {this.renderHeader()}
                <div style={{ position: 'relative', flex: 1, display: 'flex', flexDirection: 'column', minHeight: 0, overflow: 'hidden' }} >
                    <ReactTable
                        ref={(r: any) => {
                            this.tableRef = r;
                            if (this.tableRef && this.tableRef.getResolvedState() && this.props.passDataForExport) {
                                const data = this.tableRef.getResolvedState().sortedData;
                                this.props.passDataForExport(data, this.props.columns);
                            }
                        }}
                        style={{ flex: 1 }}
                        onChange={() => {
                            // alert('on change');
                            if (this.props.onFilterChange) {
                                const data = this.tableRef.getResolvedState().sortedData;
                                this.props.onFilterChange(this.state.filters, data);
                            }
                        }}
                        filtered={this.state.filters}
                        onFilteredChange={(filters: any) => this.setState({ filters }, () => {
                            this.countFiltered();
                            if (this.props.onFilterChange) {
                                const data = this.tableRef.getResolvedState().sortedData;
                                this.props.onFilterChange(filters, data);
                            }
                        })}
                        className={classNames('-striped', '-highlight', style.medium,
                            (this.props.fixedHeader ? 'ReactTableFixedHeader' : undefined),
                            (this.props.customClass ? this.props.customClass : undefined),
                            (this.props.customClassNames ? this.props.customClassNames : undefined),
                            this.props.module
                        )}
                        data={this.props.columns && this.props.columns.length > 0 ? dataVerified : undefined}
                        columns={this.state.columns}
                        showPagination={this.props.showPagination ? this.props.showPagination : false}
                        filterable={this.props.filterable ? this.props.filterable : true}
                        key={tableKey}
                        getTdProps={this.getCellStyle()}
                        getTrProps={this.props.customTrProps}
                        pageSize={pageSize}
                        defaultPageSize={pageSize}
                        previousText={'<<<<'}
                        nextText={'>>>>'}
                        pageText={i18n('Seite', 'sys')}
                        ofText={i18n('von', 'sys')}
                        noDataText={i18n('Keine Daten vorhanden', 'sys')}
                        showPaginationTop={true}
                        showPaginationBottom={false}
                        showPageSizeOptions={false}
                        pivotBy={this.props.pivotBy}
                        defaultSorted={this.props.defaultSorted}
                        collapseOnSortingChange={false}
                        collapseOnPageChange={true}
                        collapseOnDataChange={false}
                        onExpandedChange={this.onRowExpand}
                        expanded={this.state.rowsExpanded}
                        onSortedChange={this.onSortedChange}
                        column={this.columRender}
                        page={showPage}
                        onPageChange={(page: number) => this.setState({ currentPage: page })}
                    />
                    {this.props.showSpinner && <WSpinner />}
                </div>
                {this.state.dialogHistory}
                {this.state.dialogStore}
                {this.renderDlgFieldGroup()}
            </div>
        );
    }

    renderHeader() {
        const { theme } = this.props;
        const cntHiddenByFieldGroups = this.hasHiddenByFieldGroups();
        const extElements = this.props.externalHeaderElements;
        let intElements: Array<JSX.Element> = [];
        if (!this.props.hideExport) {
            intElements.push(
                <WActionButton
                    style={theme ? `theme_${theme}` : 'theme'}
                    label={this.props.dataForSaveOriginal ? 'Export Original Table to Excel' : 'Export Table to Excel'}
                    action={'export'}
                    key={'action_export'}
                    place='bottom'
                    onAction={this.props.dataForSaveOriginal ? () => this.onOriginalLoad() : () => this.onExport()}
                    tooltip={i18n('Die Exportdatei wird erstellt '
                        + 'und sofort heruntergeladen. Ihr Browser erkennt diesen Prozess und behandelt die heruntergeladene Datei '
                        + 'wie üblich/konfiguriert.', 'sys')}
                />
            );
            intElements.push(
                <WActionButton
                    style={theme ? `theme_${theme}` : 'theme'}
                    label='Export Table to Excel'
                    action={'exportToMail'}
                    key={'action_exportToEmail'}
                    place='bottom'
                    onAction={() => this.setState({ showExportToEmailPrompt: true })}
                    tooltip={i18n('Die Exportdatei wird erstellt. '
                        + 'Via Dialog können Sie eine Ziel-Emailadresse eingeben. An diese wird die Exportdatei dann versendet.', 'sys')
                    }
                />
            );
        }
        if (this.hasFieldGroups()) {
            intElements.push(
                <div
                    key={'action_fieldGroups'}
                    onMouseEnter={(e: any) => {
                        this.setState({
                            showDlgFieldGroup: true,
                            floatboxPosY: e.target.offsetParent.getBoundingClientRect().top,
                            floatboxPosX: e.target.offsetParent.getBoundingClientRect().left + 10
                        });
                    }}
                >
                    <WActionButton
                        style={theme ? `theme_${theme}` : 'theme'}
                        indicatorValue={cntHiddenByFieldGroups > 0 ? cntHiddenByFieldGroups : null}
                        indicatorColor={cntHiddenByFieldGroups > 0 ? 'black' : null}
                        label='Spaltengruppen ein/ausblenden'
                        action='unshow'
                        place='bottom'
                        key={'action_field_groups'}
                        onAction={() => { }}
                        tooltip={'Spaltengruppen ein/ausblenden'}
                    />
                </div>
            );
        }
        if (!this.props.hideFilterReset) {
            intElements.push(
                <WActionButton
                    style={theme ? `theme_${theme}` : 'theme'}
                    label={i18n('Filter zurücksetzen', 'sys')}
                    action={'resetFilter'}
                    place='bottom'
                    key={'action_clearFilter'}
                    onAction={() => {
                        this.setState({ filters: [] });
                        if (this.props.onResetFilter) {
                            this.props.onResetFilter();
                        }
                    }}
                    tooltip={i18n('Filter zurücksetzen', 'sys')}
                />
            );
        }
        intElements.push(this.renderBtnShowHistory());
        intElements.push(this.renderBtnSetStore());
        intElements.push(this.renderBtnShowStore());
        intElements = intElements.concat(extElements);
        intElements.push(
            <div
                key='info_filter'
                style={{
                    display: 'flex', flexDirection: 'column', justifyContent: 'center', marginTop: 2, marginLeft: 5,
                    height: 35, lineHeight: 1, fontSize: 11, fontStyle: 'italic'
                }}
            >
                <div>
                    {'  ' + this.props.data ? `${this.props.data.length} ${i18n('Datensätze insgesamt', 'sys')}` : i18n('Keine Daten vorhanden', 'sys')}
                </div>
                <div>
                    {'  ' + this.props.data && this.props.data.length &&
                        this.state.countFiltered !== undefined && this.state.countFiltered < this.props.data.length ?
                        `${this.state.countFiltered} ${i18n('Datensätze nach Filterung', 'sys')}` : ''
                    }
                </div>
            </div>
        );
        this.sortHeaderElements(intElements);

        return !this.props.hideAllHeaderElements &&
            <div>
                {this.state.showExportToEmailPrompt && this.renderExportToEmailPrompt()}
                <div className={classNames(style.rowContainer, style['rowContainer_' + this.props.module])}
                    style={{ display: 'flex' }}>
                    {intElements}
                    {this.renderTableHelp()}
                </div>
                {this.props.extraFilter && this.props.extraFilter.length > 0 && this.props.extraFilter}
            </div>;
    }

    sortHeaderElements(elements: Array<JSX.Element>) {
        const sequ = this.props.sortHeaderElements ? this.props.sortHeaderElements :
            ['action_add', 'action_reload', 'action_clearFilter', 'action_export', 'action_exportToEmail'];
        elements.sort((a: any, b: any) => {
            let ai = elements.length;
            let bi = ai;
            a = a || {};
            b = b || {};
            if (typeof a.key === 'string') {
                const asi = sequ.indexOf(a.key);
                if (asi !== -1) {
                    ai = asi;
                }
            }
            if (typeof b.key === 'string') {
                const bsi = sequ.indexOf(b.key);
                if (bsi !== -1) {
                    bi = bsi;
                }
            }
            if (ai < bi) {
                return -1;
            }
            if (ai > bi) {
                return 1;
            }
            return 0;
        });
    }

    onRowExpand(newExpanded: Array<any>) {
        this.setState({ rowsExpanded: newExpanded });
        if (this.props.onRowExpand) {
            this.props.onRowExpand(newExpanded);
        }
    }

    // getRowsExpanded() {
    //     if (this.tableRef) {
    //         const keys = this.state.expandedKeys;
    //         const resolvedData = this.tableRef.getResolvedState().resolvedData;
    //         const expanded = resolvedData.map((rd: any) => {
    //             return this.state && keys.indexOf(rd._pivotVal) !== -1 ? true : false;
    //         });
    //         return expanded;
    //     }
    //     return [];
    // }

    // onRowExpand(rows: any) {
    //     const resolvedData = this.tableRef.getResolvedState().resolvedData;
    //     const expandedKeys = Object.keys(rows).map((rowidx: any) => {
    //         if (rows[+rowidx] !== false && resolvedData[+rowidx]) {
    //             return resolvedData[+rowidx]._pivotVal;
    //         }
    //     });
    //     this.setState({ expandedKeys });
    // }

    private countFiltered() {
        const data = this.tableRef.getResolvedState().sortedData;
        this.setState({ countFiltered: data.length });
    }
    private getCellStyle() {
        if (this.props.customTdProps) {
            return this.props.customTdProps;
        }
        if (this.props.pivotBy) {
            return;
        }
        const enableSelection = this.props.enableSelection;
        const multipleSelection = this.props.multipleSelection;
        const arrayOfSelectedRow = this.state.selectedRowForArray;
        return (state: any, rowInfo: any) => {  // (state, rowInfo, column, instance) -- wir brauchen nur die row
            if (rowInfo && rowInfo.row) {
                return {
                    onClick: enableSelection ? (e: any) => {
                        this.setState({
                            selectedRow: rowInfo.index
                        });

                        if (this.props.onSelection) {
                            this.props.onSelection(rowInfo.index);
                        }
                    } :
                        multipleSelection ? (e: any) => {
                            if (arrayOfSelectedRow.indexOf(rowInfo.index) !== -1) {
                                const index = arrayOfSelectedRow.indexOf(rowInfo.index);
                                arrayOfSelectedRow.splice(index, 1);
                            } else {
                                arrayOfSelectedRow.push(rowInfo.index);
                            }

                            this.setState({ selectedRowForArray: arrayOfSelectedRow, selectedRow: rowInfo.index });
                            if (this.props.onSelection) {
                                this.props.onSelection(arrayOfSelectedRow);
                            }
                        } :
                            (e: any) => {
                                // console.log(rowInfo);
                            },
                    style:
                        (!multipleSelection && rowInfo.index === this.state.selectedRow) && arrayOfSelectedRow.length === 0 ||
                            arrayOfSelectedRow.indexOf(rowInfo.index) !== -1 ? { color: 'white', background: '#00afec' }
                            :
                            rowInfo.row._original && rowInfo.row._original.internal &&
                                rowInfo.row._original.internal._diffState ?
                                DiffTool.getDiffStyle(rowInfo.row._original.internal._diffState) : {}

                };
            } else {
                return {};
            }
        };
    }


    private onExport() {
        const et = new ExcelTool();
        const data = this.tableRef.getResolvedState().sortedData;
        let title = this.props.entity + '_export';
        if (this.props.exportOptions && typeof this.props.exportOptions.title === 'string') {
            title = this.props.exportOptions.title;
        }
        if (this.props.rawData) {
            console.log('Export Raw-Data', this.props.rawData);
            et.dataToWb(title, this.props.columns, this.props.rawData, this.state.sheetName,
                (sheetData: XLSX.WorkSheet) => {
                    formatDefaultExport(sheetData);
                }, this.props.exportOptions);
        } else {
            console.log('Export Show-Data');
            et.dataToWb(title, this.props.columns, data, this.state.sheetName,
                (sheetData: XLSX.WorkSheet) => {
                    formatDefaultExport(sheetData);
                }, this.props.exportOptions);
        }
    }

    private onOriginalLoad() {
        const rawData = this.props.rawData;
        if (!this.props.rawData && this.props.data) {
            this.onExport();
            return;
        }
        const et = new ExcelTool();
        et.saveOriginal(rawData);
    }

    private onExportToEmail(data: WFormData) {
        console.log('onExportToEmail');
        console.log(this.props.module);
        const et = new ExcelTool();
        if (this.props.rawData) {
            et.dataToSheetToEmailOriginal(this.props.module, this.props.entity,
                this.props.columns, this.props.data, data.getAllValues().email, this.props.rawData);
        } else {
            const dataFiltered = this.tableRef.getResolvedState().sortedData;
            et.dataToSheetToEmail(this.props.module, this.props.entity, this.props.columns, dataFiltered, data.getAllValues().email,
                (sheetData: XLSX.WorkSheet) => {
                    formatDefaultExport(sheetData);
                });
        }
        this.setState({ showExportToEmailPrompt: false });
    }
}
